/* eslint-disable import/order */
/**
 * index.tsx
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import { ConfigProvider } from 'antd';
import localeValues from 'antd/lib/locale/vi_VN';
import FontFaceObserver from 'fontfaceobserver';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import { store } from 'app/store';
import { Router } from 'configRouter';
import reportWebVitals from 'reportWebVitals';
import { theme } from 'styled';

// Use consistent styling
import 'sanitize.css/sanitize.css';
import 'styles.css';
// Import root app

import './styled/antd-custom.css';
import './styled/antd-mobile-custom.css';

// Initialize languages
import './locales/i18n';
import { StrictMode } from 'react';

// Observe loading of Be Vietnam Pro (to remove this font, remove the <link> tag in
// the index.html file and this observer)
const beVietnamProObserver = new FontFaceObserver('Be Vietnam Pro', {});

// When Be Vietnam Pro is loaded, add a font-family using it to the body
beVietnamProObserver.load().then(() => {
  document.body.classList.add('fontLoaded');
});

const MOUNT_NODE = document.getElementById('root') as HTMLElement;

ReactDOM.render(
  <ConfigProvider locale={localeValues}>
    <Provider store={store}>
      <HelmetProvider>
        <StrictMode>
          <ThemeProvider theme={theme}>
            <Router />
          </ThemeProvider>
        </StrictMode>
      </HelmetProvider>
    </Provider>
  </ConfigProvider>,
  MOUNT_NODE
);

reportWebVitals();
